import React from 'react';
import Typography from './Typography';
import activebg from '../images/Rectangle 4407.png';
import bg from '../images/Rectangle 4408.png';

const InvestmentOptionList = ({ title, value, children, icon, active = false, className, onClick }) => {
    return (
        <div className={`p-[18px] cursor-pointer relative flex items-center w-full h-[46px] ${className}`} onClick={onClick}>
            {active ? <img src={activebg} alt='activebg' className='absolute top-0 left-0 w-full h-[46px]' /> : <img src={bg} alt='bg' className='absolute top-0 left-0 w-full h-[46px]' />}
            {active && <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" className='absolute top-1 left-1'>
                <path d="M7 1L1 1L1 7" stroke="#DF0F11" />
            </svg>}
            {active && <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" className='absolute top-1 right-1' >
                <path d="M0 1L6 1L6 7" stroke="#DF0F11" />
            </svg>}
            {active && <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" className='absolute bottom-1 left-1' >
                <path d="M7 6L1 6L1 0" stroke="#DF0F11" />
            </svg>}
            {active && <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" className='absolute bottom-1 right-1' >
                <path d="M0 6L6 6L6 0" stroke="#DF0F11" />
            </svg>}
            <div className="relative z-10 flex items-center w-full justify-between text-white">
                {/* <div className='mt-14'>{icon}</div> */}
                {title && <Typography color={'#FFF'} size={'14px'} family={'Supply'} weight={400} transform={'uppercase'} text={title} />}
                {active && <div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_1797_8554" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1797_8554)">
                        <path d="M10.6 16.2L17.65 9.15L16.25 7.75L10.6 13.4L7.75 10.55L6.35 11.95L10.6 16.2ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z" fill="#DF0F11" />
                    </g>
                </svg></div>}
            </div>
        </div>
    );
};

export default InvestmentOptionList;